export const Paginator = props => (
	<nav class="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6">
		<p class="text-sm text-gray-700 hidden sm:block">
			Showing
			<span class="font-medium">&nbsp;{props.page * props.pageSize + 1}&nbsp;</span>
			to
			<span class="font-medium">
				&nbsp;
				{Math.min( ( props.page + 1 ) * props.pageSize, props.total )}
				&nbsp;
			</span>
			of
			<span class="font-medium">&nbsp;{props.total}&nbsp;</span>
			{props.itemName}
		</p>
		<div class="flex flex-1 justify-between sm:justify-end">
			<button
				type="button"
				disabled={props.page === 0}
				onClick={() => props.setPage( ( p ) => p - 1 )}
				class="disabled:bg-gray-50 disabled:text-gray-500 cursor-pointer relative inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-700 inset-ring inset-ring-gray-300 hover:bg-gray-50"
			>
				Previous
			</button>
			<button
				type="button"
				disabled={( props.page + 1 ) * props.pageSize >= props.total}
				onClick={() => props.setPage( ( p ) => p + 1 )}
				class="disabled:bg-gray-50 disabled:text-gray-500 cursor-pointer relative ml-3 inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-700 inset-ring inset-ring-gray-300 hover:bg-gray-50"
			>
				Next
			</button>
		</div>
	</nav>
)